import { CompRef } from '@wix/document-services-types';
import { ManifestServicesHost } from '@wix/editor-platform-manifest-services';
import { EditorPointer } from '@wix/editor-document-logic-api';

/**
 * I guess this service should be part of ManifestServicesHost
 * since prob we don't want to expose virtualManifestID, let's keep it within manifest services only
 */
export class PrivateApiBIUtils {
  constructor(private readonly manifestServicesHost: ManifestServicesHost) {}

  getEditorPointersForBI(
    virtualManifestId: string,
    childPath: number[],
  ): EditorPointer<CompRef>[] {
    const api = this.manifestServicesHost.getContextualManifestAPI(
      virtualManifestId,
      childPath,
    );

    if (api.node.isMultipleComponentsRoot()) {
      return api.node
        .getVirtualManifest()
        .manifests.map((x) => x.editorPointer)
        .filter(Boolean);
    }
    return [api.getEditorPointer()];
  }
}
